module.exports = __webpack_public_path__ + "04_glasses_blue.710c202a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/04_glasses_blue.png
// module id = r4xQ
// module chunks = 0